import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { Redirect } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';

import { contactsRef, usersRef } from '../../firebase';
import { toast } from 'react-toastify';

const styles = theme => ({
    title: {
        paddingLeft: '2%',
        paddingRight: '5%',
        paddingTop: '2%',
        paddingBottom: '5rem',
    },
    close: {
        width: theme.spacing.unit * 4,
        height: theme.spacing.unit * 4,
    },
});

class AddContact extends Component {
    constructor(props) {
        super(props);

        const { id } = props.match.params;
        let mode = false;

        if (id) {
            mode = true;
        }

        this.onSubmit = this.onSubmit.bind(this);

        this.state = {
            email: '',
            firstName: '',
            lastName: '',
            phone: '',
            refId: this.props.myId,
            mode: mode,
            loading: mode,
        }
        if (mode) {
            contactsRef.doc(id).get()
                .then((doc) => {
                    var data = doc.data();
                    
                    this.setState({ 
                        firstName: data['firstName'], 
                        lastName: data['lastName'], 
                        email: data['email'],
                        phone: data['phone'],
                        refId: data['refId'],
                        id: id,
                        loading: false
                    });
                });
        }
    }

    onSubmit(e) {
        e.preventDefault();
        if (!this.state.saving) {
            if (this.state.firstName === '' || this.state.lastName === '' 
                || this.state.email === '' || this.state.phone === '') {
                /* Push.create("KBAAZ", {
                    body: "Please fillout all fields!!!",
                    logo: './k-logo.png',
                    timeout: 4000,
                    onClick: function () {
                        window.focus();
                        this.close();
                    }
                });
 */
                toast.warn('Please fill out all fields!', {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                
            } else {
                this.setState({ saving: true });
               
                usersRef.where('email', '==', this.state.email).get()
                    .then(querySnap => {
                        let userId = ''

                        if(querySnap.size > 0) {
                            userId = querySnap.docs[0].id
                        }

                        const contactData = {
                            firstName: this.state.firstName,
                            lastName: this.state.lastName,
                            email: this.state.email,
                            phone: this.state.phone,
                            refId: this.props.myId,
                            accepted: false,
                            pending: true,
                            userId
                        }

                        if (!this.state.mode) {
                            contactsRef.add(contactData)
                                .then(() => {
                                    /* Push.create("KBAAZ", {
                                        body: "Contact saved successfully",
                                        logo: './k-logo.png',
                                        timeout: 4000,
                                        onClick: function () {
                                            window.focus();
                                            this.close();
                                        }
                                    }); */
                                    toast.success('Contact saved successfully!', {
                                        position: "bottom-right",
                                        autoClose: 5000,
                                        hideProgressBar: true,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                    });
                                    this.setState({ saving: false });
                                    this.setState({ redirect: true });
                                })
                                .catch(() => {
                                    /* Push.create("KBAAZ", {
                                        body: "Error occurred",
                                        logo: './k-logo.png',
                                        timeout: 4000,
                                        onClick: function () {
                                            window.focus();
                                            this.close();
                                        }
                                    }); */
                                    toast.error('Error occurred!', {
                                        position: "bottom-right",
                                        autoClose: 5000,
                                        hideProgressBar: true,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                    });
                                    this.setState({ saving: false });
                                });
                        } else {
                            contactsRef.doc(this.state.id).set(contactData)
                                .then(() => {
                                    /* Push.create("KBAAZ", {
                                        body: "Contact saved successfully",
                                        logo: './k-logo.png',
                                        timeout: 4000,
                                        onClick: function () {
                                            window.focus();
                                            this.close();
                                        }
                                    }); */
                                    toast.info('Contact saved successfully!', {
                                        position: "bottom-right",
                                        autoClose: 5000,
                                        hideProgressBar: true,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                    });
                                    this.setState({ saving: false });
                                    this.setState({ redirect: true });
                                })
                                .catch(() => {
                                    /* Push.create("KBAAZ", {
                                        body: "Error occurred",
                                        logo: './k-logo.png',
                                        timeout: 4000,
                                        onClick: function () {
                                            window.focus();
                                            this.close();
                                        }
                                    }); */
                                    toast.info('Error occurred!', {
                                        position: "bottom-right",
                                        autoClose: 5000,
                                        hideProgressBar: true,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                    });
                                    this.setState({ saving: false });
                                });
                        }
                    })

                
            }
        }
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    componentWillMount() {
        ValidatorForm.addValidationRule('isNameValid', (value) => {
            if (value.length > 20) {
                return false;
            }
            return true;
        });

        ValidatorForm.addValidationRule('isPhoneValid', (value) => {
            if (value.match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im)) {
                return true;
            }
            return false;
        });
    }

    render() {
        const { classes } = this.props;             

        if (this.state.redirect) {
            return (
                <Redirect to="/contacts" />
            );
        }

        if (this.state.loading) {
            return (
                <h2>Loading...</h2>
            );
        }

        return (
            <div className={classes.title}>
                <ValidatorForm
                    ref="form"
                    onSubmit={this.onSubmit.bind(this)}
                >
                <Grid container spacing={40} style={{ paddingBottom:'50px' }}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Typography gutterBottom={false} color="primary" variant="display1">Create Contact</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <TextValidator
                            style={{ width: '80%' }}
                            label="FirstName"
                            onChange={this.handleChange('firstName')}
                            name="firstname"
                            value={this.state.firstName}
                            validators={['required', 'isNameValid']}
                            errorMessages={['this field is required', 'must be less than 20 chars']}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <TextValidator
                            style={{ width: '80%' }}
                            label="Last Name"
                            onChange={this.handleChange('lastName')}
                            name="lastname"
                            value={this.state.lastName}
                            validators={['required', 'isNameValid']}
                            errorMessages={['this field is required', 'must be less than 20 chars']}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <TextValidator
                            style={{ width: '80%' }}
                            label="Email"
                            onChange={this.handleChange('email')}
                            name="email"
                            value={this.state.email}
                            validators={['required', 'isEmail']}
                            errorMessages={['this field is required', 'enter valid email']}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <TextValidator
                            style={{ width: '80%' }}
                            label="Phone number"
                            onChange={this.handleChange('phone')}
                            name="phone"
                            value={this.state.phone}
                            validators={['required', 'isPhoneValid']}
                            errorMessages={['this field is required', 'enter a vaild phone number']}
                        />
                    </Grid>
                </Grid>
                <Button type='submit' color="primary" variant="outlined">SAVE</Button>
                </ValidatorForm>
            </div>
        );
    }
}

AddContact.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AddContact);



// WEBPACK FOOTER //
// ./src/components/Contacts/AddContact.js